module.exports = __webpack_public_path__ + "img/cutout_color-splash.9d301e3.svg";